import React, {useEffect} from 'react'
import {Provider} from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import {ConnectedRouter, routerMiddleware} from 'react-router-redux'
import * as Sentry from '@sentry/react';
import {Integrations} from "@sentry/tracing";
import {NotificationsManager} from 'advenio-components'
import {Api} from 'auth-advenio'
import {SENTRY_URL, SENTRY_ENV} from '../config'
import {gb} from '../utils/growthbook'
import AuthContainer from './AuthContainer'
import './Styles/App.css'
import {ToastContainer, toast} from 'react-toastify';

import createStore from '../Data/Redux'

// Create a browser history
const history = createHistory()

// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history)

// Create our store, with middlewares
const store = createStore([historyMiddleware])
Api.setStore(store)

if (SENTRY_ENV !== 'development') {
  Sentry.init({
    dsn: `https://${SENTRY_URL}`,
    environment: `${SENTRY_ENV}`,
    normalizeDepth: 10,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV4Instrumentation(history),
        tracePropagationTargets: ["localhost", /^https:\/\/api-qa\.miadvenio\.com/],
      }),
    ],
    // release: '1.01.23',

    // // We recommend adjusting this value in production, or using tracesSampler
    // // for finer control
    tracesSampleRate: 1.0,
  });
}


const App = () => (
  <Provider store={store}>
    { /* ConnectedRouter will use the store from Provider automatically */}
    <div>
      <ConnectedRouter history={history}>
        <AuthContainer/>
      </ConnectedRouter>
      <NotificationsManager timeout={2500}/>
      <ToastContainer
        position="bottom-right"
        autoClose={60000} // 60000 milisegundos = 1 minuto
        theme="colored"
      />

    </div>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/Containers/App.jsx